import { makeStyles } from '@material-ui/styles'

export const useMobileReturnStyles = makeStyles((theme) => ({
  container: {
    height: 56,
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: theme.shadows[2],
    padding: theme.spacing(0, 3),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      display: 'flex',
    },
  },
  icon: {
    '&.material-icons': {
      color: theme.palette.loading.iconColor,
      fontSize: `${theme.typography.pxToRem(30)} !important`,
    },
  },
  title: {
    flex: 2,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.loading.color,
    fontSize: theme.typography.pxToRem(20),
  },
}))
